<template>
  <div class="page">
    <div class="centered-box locations-white locations-generic">
      <div class="row">
        <div class="col">
          <!-- <div class="locations-title">OPENING SOON</div> -->
            <div class="home-text">
              <!-- <em>Opening <strong>Friday, April 19</strong></em> -->
              <br /><br />
              We’re done renting for the season, and we’re headed into hibernation. A huge THANK YOU to the many thousands of you who helped make our 2024 season a success. We’ll be back to get you on the water by May 2024. Stay well, stay safe, and we’ll see you then.            </div>
            <!-- <div class="text-center">And, WE'RE HIRING. For more information, see our Events/Employment tab.       -->
            <!-- <br /><br /> -->
            <!-- <i>Special Note: Our Maple Lake boathouse will remain closed until May 2024</i> -->
            <br /><br /> 
            <a class="btn-primary btn" href="#/contact">      
            <strong>Contact</strong>
            </a>
            </div>
          </div>
        </div>
      </div>
  <!-- 
  <div class="page"></div>-->
</template>

<script>
export default {
  name: "Home",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.col {
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.home-text {
  text-align: center;
}
.red {
  color: red;
}
.page {
  background-image: url("../assets/pic13.png");
  flex-direction: column;
}
a.btn:hover {
  color: rgb(192, 80, 77) !important;
}
ul {
  list-style-type: none;
}
a.btn-primary {
  margin-top: -35px;
  margin-bottom: 2px;
  text-align: center;
  display: inline-block;
  display: block;
}
i {
  text-align: center;
  display: block;
}
</style>
